// Formatação e paleta do BI (segue BRANDSYSTEM: brand indigo + accents pra categorizar).
export const PALETA = ["#6366F1", "#10B981", "#F59E0B", "#3B82F6", "#8B5CF6", "#F43F5E", "#06B6D4", "#84CC16", "#EC4899", "#14B8A6", "#F97316", "#A3A3A3"];

export function formatar(v, formato) {
    if (v === null || v === undefined || Number.isNaN(Number(v))) return "—";
    const n = Number(v);
    switch (formato) {
        case "moeda": return "R$ " + n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case "pct": return n.toLocaleString("pt-BR", { maximumFractionDigits: 1 }) + "%";
        case "x": return n.toLocaleString("pt-BR", { maximumFractionDigits: 2 }) + "×";
        case "decimal": return n.toLocaleString("pt-BR", { maximumFractionDigits: 1 });
        case "inteiro":
        default: return Math.round(n).toLocaleString("pt-BR");
    }
}

export function formatarCurto(v, formato) {
    if (v === null || v === undefined) return "—";
    const n = Number(v);
    const abs = Math.abs(n);
    const k = abs >= 1e6 ? (n / 1e6).toLocaleString("pt-BR", { maximumFractionDigits: 1 }) + "M" : abs >= 1e3 ? (n / 1e3).toLocaleString("pt-BR", { maximumFractionDigits: 1 }) + "k" : n.toLocaleString("pt-BR", { maximumFractionDigits: formato === "moeda" ? 0 : 1 });
    if (formato === "moeda") return "R$ " + k;
    if (formato === "pct") return k + "%";
    if (formato === "x") return k + "×";
    return k;
}

// Métricas em que menor é melhor (pro sinal verde/vermelho do comparativo)
export const MENOR_MELHOR = new Set(["cpm", "cpc", "cpa_real", "cpa_meta", "custo_lpv", "custo_lead", "custo_visitante", "custo_checkout_meta", "imp_por_clique", "imp_por_lpv"]);
export const NEUTRA = new Set(["spend", "gasto_com_imposto", "impressions", "reach", "diff_compras"]);

export function delta(atual, anterior) {
    if (anterior === null || anterior === undefined || atual === null || atual === undefined) return null;
    const a = Number(atual), b = Number(anterior);
    if (!b) return a ? Infinity : 0;
    return ((a - b) / Math.abs(b)) * 100;
}

export function diaCurto(iso) {
    if (!iso) return "";
    const [, m, d] = String(iso).split("-");
    return `${d}/${m}`;
}
